import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { functions } from "../constants/common-functions";
import ChildDirectory from "../components/ResourcesDirectory";

/* ======================================================
   CONSTANTS
   ====================================================== */

const INDENT_SIZE = 14;

/* ======================================================
   COMPONENT
   ====================================================== */

export default function ResourcesDirectory({
  id,
  depth = 0,
  name,
  setFilesFunction,
  selectedDirectoryId,
  setSelectedDirectoryIdFunction
}) {

  /* =========================
     STATE
     ========================= */

  const [thisWidth, setThisWidth] = useState("");
  const [thisMarginLeft, setThisMarginLeft] = useState("");
  const [thisIcon, setThisIcon] = useState("plus");
  const [displayDirectories, setDisplayDirectories] = useState("none");
  const [directories, setDirectories] = useState([]);
  const [thisBackground, setThisBackground] = useState("rgba(0,0,0,0)");
  const [thisForeground, setThisForeground] = useState("white");

  /* =========================
     EFFECT – LAYOUT
     ========================= */

  useEffect(() => {

    const marginLeft = depth * INDENT_SIZE;

    setThisMarginLeft(marginLeft + "px");
    setThisWidth("calc(100% - " + marginLeft + "px)");

    if (selectedDirectoryId !== id) {
      setThisBackground("rgba(0,0,0,0)");
      setThisForeground("white");
    }

  }, [id, depth, selectedDirectoryId]);

  /* =========================
     STYLES
     ========================= */

  const thisContainer = {
    display: "flex",
    width: thisWidth,
    marginLeft: thisMarginLeft,
    alignItems: "flex-start",
    flexDirection: "column"
  };

  const topContainer = {
    display: "flex",
    width: "100%",
    height: "28px",
    alignItems: "center"
  };

  const iconContainer = {
    display: "flex",
    width: "14px",
    height: "14px",
    margin: "6px",
    border: "1px solid rgba(255,255,255,0.35)",
    cursor: "pointer",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px"
  };

  const iconStyle = {
    fontSize: "10px",
    color: "rgba(255,255,255,0.75)"
  };

  const nameContainer = {
    display: "flex",
    fontSize: "14px",
    color: thisForeground,
    cursor: "pointer",
    padding: "4px 10px",
    borderLeft: "3px solid " + thisBackground,
    minWidth: "150px",
    transition: "background 120ms ease"
  };

  const directoryContainer = {
    display: displayDirectories,
    flexDirection: "column",
    width: "calc(100% - 14px)",
    borderLeft: "1px solid rgba(255,255,255,0.15)",
    marginLeft: "14px"
  };

  const line = {
    display: "flex",
    width: "14px",
    height: "1px",
    backgroundColor: "rgba(255,255,255,0.2)",
    marginLeft: "-14px"
  };

  /* =========================
     HANDLERS
     ========================= */

  const handleIconClick = () => {

    if (thisIcon === "plus") {

      setThisIcon("minus");
      setDisplayDirectories("flex");

      functions.getArrayFromAjax(
        "/resolutionsoftwareplatform/resources/directories/" + id + "/children",
        null,
        setDirectories
      );

    } else {

      setThisIcon("plus");
      setDisplayDirectories("none");
      setDirectories([]);
    }
  };

  const handleNameClick = () => {

    setFilesFunction(id);

    if (selectedDirectoryId !== id) {

      setSelectedDirectoryIdFunction(id);
      setThisBackground("#3d7bff");
      setThisForeground("white");

    } else {

      setSelectedDirectoryIdFunction("-100");
      setThisBackground("rgba(0,0,0,0)");
      setThisForeground("white");
    }
  };

  const getLineDisplay = () => {
    return depth > 0 ? <div style={line} /> : <div />;
  };

  /* =========================
     CHILD DIRECTORIES
     ========================= */

  const directoryDisplay = directories.map(item => (
    <ChildDirectory
      key={item.id}
      id={item.id}
      name={item.name}
      depth={depth + 1}
      setFilesFunction={setFilesFunction}
      selectedDirectoryId={selectedDirectoryId}
      setSelectedDirectoryIdFunction={setSelectedDirectoryIdFunction}
    />
  ));

  /* =========================
     RENDER
     ========================= */

  return (
    <div style={thisContainer}>

      <div style={topContainer}>
        {getLineDisplay()}

        <div style={iconContainer} onClick={handleIconClick}>
          <FontAwesomeIcon icon={thisIcon} style={iconStyle} />
        </div>

        <div
          style={nameContainer}
          onClick={handleNameClick}
          onMouseEnter={() => {
            if (selectedDirectoryId !== id) {
              setThisBackground("rgba(61,123,255,0.25)");
            }
          }}
          onMouseLeave={() => {
            if (selectedDirectoryId !== id) {
              setThisBackground("rgba(0,0,0,0)");
            }
          }}
        >
          {name}
        </div>
      </div>

      <div style={directoryContainer}>
        {directoryDisplay}
      </div>

    </div>
  );
}
